var nurseslounge_myDashboard_recommendations = {
    init:function($params){
        var $userId = libs.memoryGet('user_id');
        if($userId != 'guest'){
            $params = $.extend({}, $params, {user_id:$userId});
            nurseslounge_myDashboard_recommendations.recommendations($params);
        }
    },
    recommendations:function($params){
        nurseslounge_myDashboard_recommendations.get_recommendations($params, function($data){
            nurseslounge_myDashboard_recommendations.recommendation_section('lounges', $data);
        });
    },
    get_recommendations:function($params, cback){
        $.ajax({
            url: "/recommendations/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    recommendation_section:function($section, $data){
        var $modal = $("#nurseslounge-recommended-lounges-modal");
        var $modalBody = $modal.find(".modal-body");
        var $modalTitle = $modal.find(".modal-title");
        var $chtml = '';
        switch ($section){
            case 'lounges':
                $modalTitle.html('Lounge Recommendations');
                $chtml += '' +
                    '<ul class="list-items lounge-list">' + nurseslounge_myDashboard_recommendations.lounge_item_html($data.data.lounges) + '</ul>' +
                    '<div class="row mt-3">' +
                    '   <div class="col-6">' +
                    '       <button type="button" class="btn btn-light skip w-100">Skip</button>' +
                    '   </div>' +
                    '   <div class="col-6">' +
                    '       <button type="button" class="btn btn-save btnAnimate follow-all w-100">Follow All</button>' +
                    '   </div>' +
                    '</div>';
                break;
            case 'degrees':
                $modalTitle.html('Degrees Recommendations');
                $chtml += '' +
                    '<ul class="list-items degree-list">' + nurseslounge_myDashboard_recommendations.degree_item_html($data.data.lounge_degrees) + '</ul>' +
                    '<div class="row mt-3">' +
                    '   <div class="col-12">' +
                    '       <button type="button" class="btn btn-light skip w-100">Skip</button>' +
                    '   </div>' +
                    '</div>';
                break;
            case 'jobs':
                $modalTitle.html('Jobs Recommendations');
                $chtml += '' +
                    '<ul class="list-items job-list">' + nurseslounge_myDashboard_recommendations.job_item_html($data.data.jobs) + '</ul>' +
                    '<div class="row mt-3">' +
                    '   <div class="col-12">' +
                    '       <button type="button" class="btn btn-light skip w-100">Skip</button>' +
                    '   </div>' +
                    '</div>';
                break;
        }
        libs.checkImageLoad($($chtml).find('img'), function(){
            $modalBody.html($chtml).promise().done(function() {
                switch ($section) {
                    case 'lounges':
                        if($data.data.lounges.length > 0){
                            nurseslounge_myDashboard_recommendations.lounge_recommendations_events(function() {
                                nurseslounge_myDashboard_recommendations.recommendation_section('degrees', $data);
                            });
                            if(!$modal.is(':visible')){
                                $modal.modal('show');
                            }
                        }else{
                            nurseslounge_myDashboard_recommendations.recommendation_section('degrees', $data);
                        }
                        break;
                    case 'degrees':
                        if($data.data.lounge_degrees.length > 0){
                            nurseslounge_myDashboard_recommendations.degree_recommendations_events(function() {
                                nurseslounge_myDashboard_recommendations.recommendation_section('jobs', $data);
                            });
                            if(!$modal.is(':visible')){
                                $modal.modal('show');
                            }
                        }else{
                            nurseslounge_myDashboard_recommendations.recommendation_section('jobs', $data);
                        }
                        break;
                    case 'jobs':
                        if($data.data.jobs.length > 0){
                            nurseslounge_myDashboard_recommendations.job_recommendations_events();
                            if(!$modal.is(':visible')){
                                $modal.modal('show');
                            }
                        }else{
                            $modal.modal('hide');
                        }
                        break;
                }
            });
        });
    },
    lounge_item_html:function($lounges){
        var $chtml = '';
        $.each($lounges, function($i, $v){
            var $img = $v.logo_root_lounge;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-key="'+$v.key+'">' +
                '    <div class="row open-lounge">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="lounge">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name">' +
                '                         <a href="javascript:void(0)">'+$v.name+'</a>' +
                '                    </h4>';
            if($v.lounge_type_id != 1 && $v.lounge_type_id != 2) {
                $chtml += '' +
                    '<p class="lounge-followers">' +
                    $v.followers_count + ' Followers' +
                    '</p>';
            }
            $chtml+='' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">';
            if($v.lounge_type_id == 1 || $v.lounge_type_id == 2){
                $chtml+='' +
                    '            <div class="clg-rating">' +
                    '                <div class="rating-stars mb-1">' +
                    nurseslounge_lounges_home.add_stars($v.rating) +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    $v.rating + ' / 5 ' +
                    '                </div>' +
                    '            </div>';
            }else{
                $chtml+='' +
                    '            <div class="clg-rating">' +
                    '                <div class="rating-stars mb-1">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '            </div>';
            }
            if($v.lounge_type_id != 1 && $v.lounge_type_id != 2){
                if($v.my_follow) {
                    $chtml +='<button type="button" class="btn btn-light follow-action follow">Followed</button>';
                }else{
                    $chtml+='<button type="button" class="btn btn-save btnAnimate follow-action">Follow</button>';
                }
            }
            $chtml+='' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    lounge_recommendations_events:function(next){
        var $modal = $("#nurseslounge-recommended-lounges-modal");
        var $loungeList = $modal.find(".lounge-list:first");
        var $skip = $modal.find(".skip:first");
        var $followAll = $modal.find(".follow-all:first");
        var $userId = libs.memoryGet('user_id');
        $loungeList.find(".follow-action").unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $follow = !$that.hasClass('follow');
            var $item = $that.parents('.item:first');
            var $key = $item.data('key');
            var $params = {user_id:$userId, key:$key, follow:$follow};
            nurseslounge_lounges_home.lounges_home_list_follower_request($params, function($data){
                if($data.status == 'success'){
                    var $follow = $data.data.follow;
                    var $members = $data.data.members;
                    $item.find('.lounge-followers:first').html($members+ ' Followers');
                    if($follow){
                        $item.find('.follow-action').removeClass('btn-save').removeClass('btnAnimate').addClass('btn-light').addClass('follow').html('Followed');
                    }else{
                        $item.find('.follow-action').removeClass('btn-light').removeClass('follow').addClass('btn-save').addClass('btnAnimate').html('Follow');
                    }
                }
            });
        });
        $loungeList.find(".open-lounge").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            window.open(window.location.origin+'/lounge/'+$key,'_blank');
        });
        $followAll.unbind().click(function(){
            $loungeList.find(".follow-action").each(function(){
               var $that = $(this);
                $that.click();
            });
            $loungeList.hide();
            next();
        });
        $skip.unbind().click(function(){
            $loungeList.hide();
            next();
        });
    },
    degree_item_html:function($loungeDegrees){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        $.each($loungeDegrees, function($i, $v){
            var $img = $v.lounge.logo_root_lounge;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-link="'+$v.link+'">';
            $chtml +='<span class="ads">';
            if($v.sponsored == 1) {
                $chtml += '<img src="/bimg/NursesLounge/pin.png">';
            }
            $chtml += '</span>';
            $chtml +='' +
                '     <div class="row open-degree">' +
                '         <div class="col align-self-center">' +
                '             <div class="d-flex">' +
                '                 <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="hospital" class="p-2">' +
                '                 </div>' +
                '                 <div class="list-info align-self-center w-100">' +
                '                     <h4 class="degree-name">' +
                '                         <a href="javascript:void(0)">'+$v.title+'</a>' +
                '                     </h4>' +
                '                     <p class="degree-university">'+$v.lounge.small_name+'</p>' +
                '                     <p class="text-muted degree-location">';
            if($v.lounge.location.address_city) {
                $chtml+='' +
                    $v.lounge.location.address_city + ', ';
            }
            if($v.lounge.location.address_state) {
                $chtml+='' +
                    $v.lounge.location.address_state;
            }
            $chtml+='' +
                '                     </p>' +
                '                 </div>' +
                '             </div>' +
                '         </div>' +
                '         <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '             <div class="clg-rating">' +
                '                 <div class="rating-stars mb-1">' +
                nurseslounge_degrees_home.add_stars($v.rating) +
                '                 </div>' +
                '                 <div class="rating-count text-center text-sm-right">' +
                $v.rating + ' / 5' +
                '                 </div>' +
                '             </div>';
            if($userId != 'guest'){
                $chtml += '<button type="button" class="btn btn-save btnAnimate open-degree">View</button>';
            }
            $chtml += '' +
                '         </div>' +
                '     </div>' +
                ' </li>';
        });
        return $chtml;
    },
    degree_recommendations_events:function(next){
        var $modal = $("#nurseslounge-recommended-lounges-modal");
        var $skip = $modal.find(".skip:first");
        var $degreeList = $modal.find(".degree-list:first");
        $degreeList.find(".open-degree").unbind().click(function(){
            var $link = $(this).parents('.item:first').data('link');
            window.open($link,'_blank');
        });
        $skip.unbind().click(function(){
            $degreeList.hide();
            next();
        });
    },
    job_item_html:function($jobs){
        var $chtml = '';
        $.each($jobs, function($i, $v){
            $chtml += '' +
                '<li class="list-group-item mb-0 p-1 item" data-link="'+$v.link+'">' +
                '    <div class="row open-job">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                   <img src="'+$v.lounge.logo_root_lounge+'?resize=50" alt="hospital" class="p-2">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <p>' +
                '                        <a href="javascript:void(0)">' + $v.title +
                '                        </a>' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    job_recommendations_events:function(){
        var $modal = $("#nurseslounge-recommended-lounges-modal");
        var $skip = $modal.find(".skip:first");
        var $jobList = $modal.find(".job-list:first");
        $jobList.find(".open-job").unbind().click(function(){
            var $link = $(this).parents('.item:first').data('link');
            window.open($link,'_blank');
        });
        $skip.unbind().click(function(){
            $modal.modal('hide');
        });
    }
};
